import {
  c,
  color,
  theme,
  is_mobile
} from './modules/settings.js';

(function ($) {
  jQuery(document).ready(function ($) {

    function getClosest(elem, selector) {
      // Element.matches() polyfill
      if (!Element.prototype.matches) {
        Element.prototype.matches =
          Element.prototype.matchesSelector ||
          Element.prototype.mozMatchesSelector ||
          Element.prototype.msMatchesSelector ||
          Element.prototype.oMatchesSelector ||
          Element.prototype.webkitMatchesSelector ||
          function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(
                s
              ),
              i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) {}
            return i > -1;
          };
      }

      // Get the closest matching element
      for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem;
      }
      return null;
    }

    let link = document.querySelectorAll('span.link');
    let parentTable;
    let parentCol;
    let parentTD;
    let prevSibling;
    let siblingContent;
    let linkContent;
    if (link.length > 0) {

      link.forEach((item) => {
        parentTable = getClosest(item, 'table');
        parentTD = getClosest(item, 'td');
        prevSibling = parentTD.previousElementSibling;
        siblingContent = prevSibling.querySelector('p');
        linkContent = parentTD.querySelector('span');

        if (linkContent.innerHTML.indexOf('[[') >= -1) {
          let articleID = linkContent.innerHTML;
          let articleIDshort = articleID.substr(2, articleID.length - 4);
          articleIDshort = articleIDshort.substring(0, articleIDshort.indexOf(']'));
          parentTD.classList.add('js-modified');
          parentTD.remove();
          parentTable.classList.add('js-modified');
        }
        if (linkContent.innerHTML.indexOf('?p=') !== -1 || linkContent.innerHTML.indexOf('http://') !== -1 || linkContent.innerHTML.indexOf('https://') !== -1 || linkContent.innerHTML.indexOf('https://my.nswow.ch/wow') !== -1) {
          if (linkContent.innerHTML.indexOf('?p=') !== -1) {
            const newatag = document.createElement("a");
            newatag.setAttribute('href', linkContent.textContent);
            newatag.innerHTML = siblingContent.innerHTML;
            siblingContent.innerHTML = '';
            siblingContent.appendChild(newatag);
          } else if (linkContent.innerHTML.indexOf('https://my.nswow.ch/wow') !== -1) {
            // PDF
            let linkItem;
            let text = linkContent.innerText;
            const newatag = document.createElement("a");
            newatag.setAttribute('target', '_blank');

            if (text.indexOf('#') != -1) {
              let anchorName = text.split('#');
              linkItem = '#' + anchorName[1];
            } else {
              let text = linkContent.innerHTML;
              let reg = /(["'])((?:\\\1|.)*?)\1/gi;
              let textArr = text.match(reg);
              linkItem = textArr[0].split('"')[1];
            }
            newatag.setAttribute('href', linkItem);
            newatag.innerHTML = siblingContent.innerHTML;
            siblingContent.innerHTML = '';
            siblingContent.appendChild(newatag);
          } else if (linkContent.innerHTML.indexOf('http://') !== -1 || linkContent.innerHTML.indexOf('https://') !== -1) {
            const newatag = document.createElement("a");
            newatag.setAttribute('href', linkContent.textContent);
            newatag.setAttribute('target', '_blank');
            newatag.innerHTML = siblingContent.innerHTML;
            siblingContent.innerHTML = '';
            siblingContent.appendChild(newatag);
          } else {
            const newatag = document.createElement("a");
            newatag.setAttribute('href', 'http://' + linkContent.textContent);
            newatag.setAttribute('target', '_blank');
            newatag.innerHTML = siblingContent.innerHTML;
            siblingContent.innerHTML = '';
            siblingContent.appendChild(newatag);
          }
          parentTD.classList.add('js-modified');
          parentTD.remove();
          parentTable.classList.add('js-modified');
        }
      });
    }
  });
})(jQuery);
